module.exports = __webpack_public_path__ + "static/assets/1b4c0f6fa7b456547e714d0e4276eb9f.png";